import { render, staticRenderFns } from "./ExtratoFinanceiro.vue?vue&type=template&id=31d54238&scoped=true"
import script from "./ExtratoFinanceiro.vue?vue&type=script&lang=js"
export * from "./ExtratoFinanceiro.vue?vue&type=script&lang=js"
import style0 from "./ExtratoFinanceiro.vue?vue&type=style&index=0&id=31d54238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d54238",
  null
  
)

export default component.exports